import React from 'react';

const GridPattern = () => {
  return (
    <div className="fixed inset-0 pointer-events-none z-0 opacity-30">
      <svg
        className="w-full h-full"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <pattern
            id="grid-pattern"
            x="0"
            y="0"
            width="100"
            height="100"
            patternUnits="userSpaceOnUse"
          >
            <path
              d="M 50 40 L 50 60 M 40 50 L 60 50"
              stroke="rgba(255, 255, 255, 0.08)"
              strokeWidth="1.5"
              fill="none"
            />
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#grid-pattern)" />
      </svg>
    </div>
  );
};

export default GridPattern;